module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "main_content"
  }, [_c('div', {
    staticClass: "main_content_title",
    attrs: {
      "id": "aboutUs"
    }
  }, [_vm._v("\n        GRUPA KRASJA\n      ")]), _vm._v(" "), _c('aboutus'), _vm._v(" "), _c('members'), _vm._v(" "), _c('endContent')], 1)]), _vm._v(" "), _c('events'), _vm._v(" "), _c('endOfPage')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c96fab1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/homeView.vue
// module id = 29
// module chunks = 0